import React, { memo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

import { constants } from '../../constants'
import { GenericAlertModal } from '../common'

const ProtectedRoute = ({
    permission,
    config_feature_key,
    adp_configurations,
    config_restriction,
    setConfigurationRestriction,
    clearConfigurationRestriction,
    children,
}) => {
    const [isConfigRestricted, setConfigRestricted] = useState(true)

    const user_permissions = useSelector(({ auth }) => auth.user_permissions)

    const isUserRestricted = permission !== undefined && !user_permissions.includes(permission)
    const { feature_flag = [] } = adp_configurations

    useEffect(() => {
        if (feature_flag && feature_flag.length && config_feature_key) {
            const defaultName = Object.keys(constants.configFeatureFlags)
                .find(key => constants.configFeatureFlags[key] === config_feature_key)
                .toLowerCase()
            const { is_active, name } = feature_flag.find(
                ({ key }) => key === config_feature_key
            ) || {
                is_active: false,
                name: defaultName,
            }
            setConfigRestricted(!is_active)
            if (!is_active) {
                const message = `Restricted Access for ${name}`
                setConfigurationRestriction(message)
            } else if (config_restriction) {
                setConfigurationRestriction('')
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [adp_configurations])

    /*
    If the config feature is existed on page and if the feature is inactive then don't display the route
     */
    if (config_feature_key && config_feature_key.length) {
        if (isConfigRestricted && config_restriction?.length) {
            return (
                <GenericAlertModal
                    message={config_restriction}
                    toggleModal={clearConfigurationRestriction}
                />
            )
        } else if (isConfigRestricted) {
            return null
        }
    }

    return isUserRestricted ? <Navigate to="/" replace /> : <>{children}</>
}

export default memo(ProtectedRoute)
